[
    {
        "countries_a2": [
            "AG",
            "AI",
            "AL",
            "AM",
            "AQ",
            "AS",
            "AU",
            "AW",
            "AX",
            "AZ",
            "BA",
            "BB",
            "BM",
            "BS",
            "BT",
            "BV",
            "BW",
            "BY",
            "BZ",
            "CA",
            "CC",
            "CK",
            "CW",
            "CX",
            "DM",
            "ET",
            "FJ",
            "FK",
            "FM",
            "GD",
            "GH",
            "GL",
            "GM",
            "GU",
            "GY",
            "HM",
            "IL",
            "IR",
            "JM",
            "KE",
            "KG",
            "KH",
            "KI",
            "KN",
            "KZ",
            "LC",
            "LK",
            "LR",
            "LS",
            "MD",
            "MH",
            "MK",
            "MM",
            "MN",
            "MP",
            "MV",
            "MW",
            "NA",
            "NF",
            "NG",
            "NP",
            "NR",
            "NU",
            "NZ",
            "PG",
            "PH",
            "PW",
            "RU",
            "RW",
            "SB",
            "SC",
            "SG",
            "SL",
            "SR",
            "SS",
            "TJ",
            "TK",
            "TM",
            "TO",
            "TT",
            "TV",
            "TZ",
            "UA",
            "UG",
            "US",
            "UZ",
            "VC",
            "VI",
            "VU",
            "WS",
            "ZA",
            "ZM",
            "ZW",
            "SA"
        ],
        "countries_a3": [
            "ATG",
            "AIA",
            "ALB",
            "ARM",
            "ATA",
            "ASM",
            "AUS",
            "ABW",
            "ALA",
            "AZE",
            "BIH",
            "BRB",
            "BMU",
            "BHS",
            "BTN",
            "BVT",
            "BWA",
            "BLR",
            "BLZ",
            "CAN",
            "CCK",
            "COK",
            "CUW",
            "CXR",
            "DMA",
            "ETH",
            "FJI",
            "FLK",
            "FSM",
            "GRD",
            "GHA",
            "GRL",
            "GMB",
            "GUM",
            "GUY",
            "HMD",
            "ISR",
            "IRN",
            "JAM",
            "KEN",
            "KGZ",
            "KHM",
            "KIR",
            "KNA",
            "KAZ",
            "LCA",
            "LKA",
            "LBR",
            "LSO",
            "MDA",
            "MHL",
            "MKD",
            "MMR",
            "MNG",
            "MNP",
            "MDV",
            "MWI",
            "NAM",
            "NFK",
            "NGA",
            "NPL",
            "NRU",
            "NIU",
            "NZL",
            "PNG",
            "PHL",
            "PLW",
            "RUS",
            "RWA",
            "SLB",
            "SYC",
            "SGP",
            "SLE",
            "SUR",
            "SSD",
            "TJK",
            "TKL",
            "TKM",
            "TON",
            "TTO",
            "TUV",
            "TZA",
            "UKR",
            "UGA",
            "USA",
            "UZB",
            "VCT",
            "VIR",
            "VUT",
            "WSM",
            "ZAF",
            "ZMB",
            "ZWE",
            "SAU"
        ],
        "domain": "fbs.com",
        "face_id": 1098434490199868,
        "lang": "en",
        "status": "active"
    },
    {
        "countries_a2": [
            "BF",
            "BI",
            "BJ",
            "BL",
            "CD",
            "CF",
            "CG",
            "CI",
            "CM",
            "DJ",
            "GA",
            "GN",
            "HT",
            "MG",
            "ML",
            "MU",
            "NE",
            "SN",
            "TG"
        ],
        "countries_a3": [
            "BFA",
            "BDI",
            "BEN",
            "BLM",
            "COD",
            "CAF",
            "COG",
            "CIV",
            "CMR",
            "DJI",
            "GAB",
            "GIN",
            "HTI",
            "MDG",
            "MLI",
            "MUS",
            "NER",
            "SEN",
            "TGO"
        ],
        "domain": "fr-fbs.com",
        "face_id": 1626760374081891,
        "lang": "fr",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "AO",
            "BR",
            "CV",
            "GW",
            "MZ",
            "ST",
            "TL"
        ],
        "countries_a3": [
            "AGO",
            "BRA",
            "CPV",
            "GNB",
            "MOZ",
            "STP",
            "TLS"
        ],
        "domain": "ptfbs.com",
        "face_id": 635169783289878,
        "lang": "pt",
        "status": "active"
    },
    {
        "countries_a2": [
            "AO",
            "BR",
            "CV",
            "GW",
            "MZ",
            "ST",
            "TL"
        ],
        "countries_a3": [
            "AGO",
            "BRA",
            "CPV",
            "GNB",
            "MOZ",
            "STP",
            "TLS"
        ],
        "domain": "fbsbrazil.com",
        "face_id": 635169783289878,
        "lang": "pt",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "AD",
            "AR",
            "BO",
            "CL",
            "CO",
            "CR",
            "CU",
            "DO",
            "EC",
            "GQ",
            "GT",
            "HN",
            "MX",
            "NI",
            "PA",
            "PE",
            "PR",
            "PY",
            "SV",
            "UY",
            "VE"
        ],
        "countries_a3": [
            "AND",
            "ARG",
            "BOL",
            "CHL",
            "COL",
            "CRI",
            "CUB",
            "DOM",
            "ECU",
            "GNQ",
            "GTM",
            "HND",
            "MEX",
            "NIC",
            "PAN",
            "PER",
            "PRI",
            "PRY",
            "SLV",
            "URY",
            "VEN"
        ],
        "domain": "esfbs.com",
        "face_id": 1645543122388127,
        "lang": "es",
        "status": "active"
    },
    {
        "countries_a2": [
            "AD",
            "AR",
            "BO",
            "CL",
            "CO",
            "CR",
            "CU",
            "DO",
            "EC",
            "GQ",
            "GT",
            "HN",
            "MX",
            "NI",
            "PA",
            "PE",
            "PR",
            "PY",
            "SV",
            "UY",
            "VE"
        ],
        "countries_a3": [
            "AND",
            "ARG",
            "BOL",
            "CHL",
            "COL",
            "CRI",
            "CUB",
            "DOM",
            "ECU",
            "GNQ",
            "GTM",
            "HND",
            "MEX",
            "NIC",
            "PAN",
            "PER",
            "PRI",
            "PRY",
            "SLV",
            "URY",
            "VEN"
        ],
        "domain": "es-fbs.com",
        "face_id": 1645543122388127,
        "lang": "es",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "JP"
        ],
        "countries_a3": [
            "JPN"
        ],
        "domain": "jpfbs.com",
        "face_id": 828743923909088,
        "lang": "ja",
        "status": "active"
    },
    {
        "countries_a2": [
            "JP"
        ],
        "countries_a3": [
            "JPN"
        ],
        "domain": "jpfbsbroker.com",
        "face_id": 828743923909088,
        "lang": "ja",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "TH"
        ],
        "countries_a3": [
            "THA"
        ],
        "domain": "fbs.co.th",
        "face_id": 546669298821638,
        "lang": "th",
        "status": "active"
    },
    {
        "countries_a2": [
            "TH"
        ],
        "countries_a3": [
            "THA"
        ],
        "domain": "fbs.th",
        "face_id": 546669298821638,
        "lang": "th",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "BN",
            "MY"
        ],
        "countries_a3": [
            "BRN",
            "MYS"
        ],
        "domain": "ms-brokerfbs.com",
        "face_id": 1647168305559855,
        "lang": "ms",
        "status": "active"
    },
    {
        "countries_a2": [
            "BN",
            "MY"
        ],
        "countries_a3": [
            "BRN",
            "MYS"
        ],
        "domain": "brokerfbs-ms.com",
        "face_id": 1647168305559855,
        "lang": "ms",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "BN",
            "MY"
        ],
        "countries_a3": [
            "BRN",
            "MYS"
        ],
        "domain": "tradefbsms.com",
        "face_id": 1647168305559855,
        "lang": "ms",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "BN",
            "MY"
        ],
        "countries_a3": [
            "BRN",
            "MYS"
        ],
        "domain": "mstrade-fbs.com",
        "face_id": 1647168305559855,
        "lang": "ms",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "ID"
        ],
        "countries_a3": [
            "IDN"
        ],
        "domain": "indofbs-invest.com",
        "face_id": 446768289143297,
        "lang": "id",
        "status": "active"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "tur-fbs.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "CN",
            "HK",
            "MO",
            "TW"
        ],
        "countries_a3": [
            "CHN",
            "HKG",
            "MAC",
            "TWN"
        ],
        "domain": "cntrade-fbs.com",
        "face_id": 573442179760607,
        "lang": "cn",
        "status": "active"
    },
    {
        "countries_a2": [
            "CN",
            "HK",
            "MO",
            "TW"
        ],
        "countries_a3": [
            "CHN",
            "HKG",
            "MAC",
            "TWN"
        ],
        "domain": "chn-fbs.com",
        "face_id": 573442179760607,
        "lang": "cn",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "CN",
            "HK",
            "MO",
            "TW"
        ],
        "countries_a3": [
            "CHN",
            "HKG",
            "MAC",
            "TWN"
        ],
        "domain": "chinafbs-broker.com",
        "face_id": 573442179760607,
        "lang": "cn",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "CN",
            "HK",
            "MO",
            "TW"
        ],
        "countries_a3": [
            "CHN",
            "HKG",
            "MAC",
            "TWN"
        ],
        "domain": "cn-brokerfbs.com",
        "face_id": 573442179760607,
        "lang": "cn",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "CN",
            "HK",
            "MO",
            "TW"
        ],
        "countries_a3": [
            "CHN",
            "HKG",
            "MAC",
            "TWN"
        ],
        "domain": "fbs-cntrading.com",
        "face_id": 573442179760607,
        "lang": "cn",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "PK"
        ],
        "countries_a3": [
            "PAK"
        ],
        "domain": "fbspaktrade.com",
        "face_id": 535537246653677,
        "lang": "ur",
        "status": "active"
    },
    {
        "countries_a2": [
            "PK"
        ],
        "countries_a3": [
            "PAK"
        ],
        "domain": "pakistraderfbs.com",
        "face_id": 535537246653677,
        "lang": "ur",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "PK"
        ],
        "countries_a3": [
            "PAK"
        ],
        "domain": "tradewithpakfbs.com",
        "face_id": 535537246653677,
        "lang": "ur",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "PK"
        ],
        "countries_a3": [
            "PAK"
        ],
        "domain": "pakfbstrade.com",
        "face_id": 535537246653677,
        "lang": "ur",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "PK"
        ],
        "countries_a3": [
            "PAK"
        ],
        "domain": "tradefbspakistan.com",
        "face_id": 535537246653677,
        "lang": "ur",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "SA",
            "AE",
            "EG",
            "JO",
            "KW",
            "LB",
            "OM",
            "QA"
        ],
        "countries_a3": [
            "SAU",
            "ARE",
            "EGY",
            "JOR",
            "KWT",
            "LBN",
            "OMN",
            "QAT"
        ],
        "domain": "fbs-ar.com",
        "face_id": 506377443173512,
        "lang": "ar",
        "status": "active"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "broker-fbs-turkey.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "active"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "invest-fbs-tur.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "ID"
        ],
        "countries_a3": [
            "IDN"
        ],
        "domain": "brokerfbsindo.com",
        "face_id": 446768289143297,
        "lang": "id",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "ID"
        ],
        "countries_a3": [
            "IDN"
        ],
        "domain": "idnbrokerfbs.com",
        "face_id": 446768289143297,
        "lang": "id",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "ID"
        ],
        "countries_a3": [
            "IDN"
        ],
        "domain": "brokerfbsidn.com",
        "face_id": 446768289143297,
        "lang": "id",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "ID"
        ],
        "countries_a3": [
            "IDN"
        ],
        "domain": "idbrokerfbs.com",
        "face_id": 446768289143297,
        "lang": "id",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "ID"
        ],
        "countries_a3": [
            "IDN"
        ],
        "domain": "brokerfbsid.com",
        "face_id": 446768289143297,
        "lang": "id",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "ID"
        ],
        "countries_a3": [
            "IDN"
        ],
        "domain": "indobroker-fbs.com",
        "face_id": 446768289143297,
        "lang": "id",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "ID"
        ],
        "countries_a3": [
            "IDN"
        ],
        "domain": "brokerfbs-indo.com",
        "face_id": 446768289143297,
        "lang": "id",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "ID"
        ],
        "countries_a3": [
            "IDN"
        ],
        "domain": "idbroker-fbs.com",
        "face_id": 446768289143297,
        "lang": "id",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "trtradingfbs.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "tr-tradingfbs.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "trtrading-fbs.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "tr-trading-fbs.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "tradingfbstr.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "trading-fbstr.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "tradingfbs-tr.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "reserved"
    },
    {
        "countries_a2": [
            "TR"
        ],
        "countries_a3": [
            "TUR"
        ],
        "domain": "trading-fbs-turkey.com",
        "face_id": 1509615886028661,
        "lang": "tr",
        "status": "reserved"
    }
]